import Vue from 'vue';

import Vuex from 'vuex';

Vue.use(Vuex);

//业务
const actions = {

}

//方法
const mutations = {
    updateIndexColor(state,value){

        state.colorIndex = value;
    },
    updateBlogColor(state,value){

        state.colorBlog = value;
    },
    updateContactColor(state,value){

        state.colorContact = value;
    }

}

//数据层
const state = {
    //各标签激活时的颜色
    colorIndex: '',
    colorBlog: '',
    colorContact: ''
}

//拟计算属性
const getters = {

}

//导出vuex
export default new Vuex.Store({
    actions,
    mutations,
    state,
    getters
});
